import React from 'react';
import { AppStore } from '../definitions/types';
import { Provider } from 'react-redux';

import { trackInteractiveTime, trackGtmEvent, trackPageview, trackDWH } from '../modules/tracking';

interface Props {
  children?: React.ReactNode;
  store: AppStore;
}

const trackUnload = (mountTime: number) => () => {
  trackDWH('root', 'unload', {
    auto: true,
    sessionTimeMs: Date.now() - mountTime,
  });
};

export default class Root extends React.Component<Props, {}> {
  unloadTracker: () => void;

  public componentDidMount(): void {
    trackInteractiveTime(Date.now());

    const { pathname } = window.location;
    trackGtmEvent('virtpath', {
      virtpath: pathname,
    });
    trackPageview(pathname);
    let domInteractive = Number.NaN;
    let domComplete = Number.NaN;
    const performance = window.performance;
    if (
      performance?.timing?.navigationStart &&
      performance.timing.domInteractive &&
      performance.timing.domComplete
    ) {
      domInteractive = performance.timing.domInteractive - performance.timing.navigationStart;
      domComplete = performance.timing.domComplete - performance.timing.navigationStart;
    }
    trackDWH('root', 'load', {
      auto: true,
      pathname,
      domInteractive,
      domComplete,
    });
    this.unloadTracker = trackUnload(Date.now());
    window.addEventListener('beforeunload', this.unloadTracker);
  }

  componentWillUnmount(): void {
    window.removeEventListener('beforeunload', this.unloadTracker);
  }

  public render(): JSX.Element {
    const { store, children } = this.props;
    return <Provider store={store}>{children}</Provider>;
  }
}
